/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import {
    useInfiniteQuery,
    useQuery,
    useSuspenseInfiniteQuery,
    useSuspenseQuery,
} from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseInfiniteQueryResult,
    DefinedUseQueryResult,
    InfiniteData,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseInfiniteQueryOptions,
    UseSuspenseInfiniteQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    GetPendingActivitiesParams,
    PendingActionPaginatedListDto,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getPendingActivities = (
    params?: GetPendingActivitiesParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PendingActionPaginatedListDto>> => {
    return axios.get(`/api/pending-activities`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetPendingActivitiesInfiniteQueryKey = (
    params?: GetPendingActivitiesParams
) => {
    return [
        "infinite",
        `/api/pending-activities`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetPendingActivitiesQueryKey = (
    params?: GetPendingActivitiesParams
) => {
    return [`/api/pending-activities`, ...(params ? [params] : [])] as const;
};

export const getGetPendingActivitiesInfiniteQueryOptions = <
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetPendingActivitiesInfiniteQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getPendingActivities>>,
        QueryKey,
        GetPendingActivitiesParams["cursor"]
    > = ({ signal, pageParam }) =>
        getPendingActivities(
            { ...params, cursor: pageParam ?? params?.["cursor"] },
            { signal, ...axiosOptions }
        );

    return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPendingActivities>>,
        TError,
        TData,
        Awaited<ReturnType<typeof getPendingActivities>>,
        QueryKey,
        GetPendingActivitiesParams["cursor"]
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingActivitiesInfiniteQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendingActivities>>
>;
export type GetPendingActivitiesInfiniteQueryError = AxiosError<unknown>;

export function useGetPendingActivitiesInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetPendingActivitiesParams,
    options: {
        query: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendingActivities>>,
                    TError,
                    Awaited<ReturnType<typeof getPendingActivities>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivitiesInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendingActivities>>,
                    TError,
                    Awaited<ReturnType<typeof getPendingActivities>>,
                    QueryKey
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivitiesInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendingActivitiesInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendingActivitiesInfiniteQueryOptions(
        params,
        options
    );

    const query = useInfiniteQuery(
        queryOptions,
        queryClient
    ) as UseInfiniteQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPendingActivitiesQueryOptions = <
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetPendingActivitiesQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getPendingActivities>>
    > = ({ signal }) =>
        getPendingActivities(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getPendingActivities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingActivitiesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendingActivities>>
>;
export type GetPendingActivitiesQueryError = AxiosError<unknown>;

export function useGetPendingActivities<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetPendingActivitiesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendingActivities>>,
                    TError,
                    Awaited<ReturnType<typeof getPendingActivities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivities<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendingActivities>>,
                    TError,
                    Awaited<ReturnType<typeof getPendingActivities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivities<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendingActivities<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendingActivitiesQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPendingActivitiesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetPendingActivitiesQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getPendingActivities>>
    > = ({ signal }) =>
        getPendingActivities(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPendingActivities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingActivitiesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendingActivities>>
>;
export type GetPendingActivitiesSuspenseQueryError = AxiosError<unknown>;

export function useGetPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetPendingActivitiesParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getPendingActivities>>,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendingActivitiesSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPendingActivitiesSuspenseInfiniteQueryOptions = <
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetPendingActivitiesInfiniteQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getPendingActivities>>,
        QueryKey,
        GetPendingActivitiesParams["cursor"]
    > = ({ signal, pageParam }) =>
        getPendingActivities(
            { ...params, cursor: pageParam ?? params?.["cursor"] },
            { signal, ...axiosOptions }
        );

    return {
        queryKey,
        queryFn,
        ...queryOptions,
    } as UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPendingActivities>>,
        TError,
        TData,
        Awaited<ReturnType<typeof getPendingActivities>>,
        QueryKey,
        GetPendingActivitiesParams["cursor"]
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingActivitiesSuspenseInfiniteQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendingActivities>>
>;
export type GetPendingActivitiesSuspenseInfiniteQueryError =
    AxiosError<unknown>;

export function useGetPendingActivitiesSuspenseInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetPendingActivitiesParams,
    options: {
        query: Partial<
            UseSuspenseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivitiesSuspenseInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActivitiesSuspenseInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendingActivitiesSuspenseInfinite<
    TData = InfiniteData<
        Awaited<ReturnType<typeof getPendingActivities>>,
        GetPendingActivitiesParams["cursor"]
    >,
    TError = AxiosError<unknown>,
>(
    params?: GetPendingActivitiesParams,
    options?: {
        query?: Partial<
            UseSuspenseInfiniteQueryOptions<
                Awaited<ReturnType<typeof getPendingActivities>>,
                TError,
                TData,
                Awaited<ReturnType<typeof getPendingActivities>>,
                QueryKey,
                GetPendingActivitiesParams["cursor"]
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendingActivitiesSuspenseInfiniteQueryOptions(
        params,
        options
    );

    const query = useSuspenseInfiniteQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseInfiniteQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
